<template>
  <basepage
    :title="$t('List-of-Received-e-Invoices')"
    :status="status"
    :menuitems="menuItems"
    v-on:menuclick="menuClick"
  >
    <filedialog ref="filedialog"></filedialog>
    <template slot="toolbar">
      <!--
    <v-text-field v-model="aranacak" flat="" solo-inverted="" hide-details label="Ara" append-icon="search"></v-text-field>
    <v-btn :disabled="status.loading" flat @click="kayitgetir()">Ara</v-btn>
    -->
    </template>

    <v-flex xs12 sm12 md12>
      <v-form ref="formgunluksatis" lazy-validation>
        <v-card flat class="pa-3">
          <v-layout row>
            <v-flex xs12 sm12 md12>
              <v-layout row wrap>
                <v-flex xs12 sm6 md2>
                  <tarihcomp
                    :etiket="$t('Starting-Date')"
                    v-model="prm.Tarih1"
                    :detaygizle="false"
                    :rules="[(v) => !!v || $t('Please-select-a-date')]"
                    v-bind:defaultvalue="'ok'"
                  ></tarihcomp>
                </v-flex>
                <v-flex xs12 sm6 md2>
                  <tarihcomp
                    :etiket="$t('Finishing-Date')"
                    v-model="prm.Tarih2"
                    :detaygizle="false"
                    :rules="[(v) => !!v || $t('Please-select-a-date')]"
                    v-bind:defaultvalue="'ok'"
                  ></tarihcomp>
                </v-flex>
                <v-flex xs12 sm6 md2>
                  <v-text-field
                    label="ETTN / Fat. No"
                    v-model="prm.EttnFaturaNo"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm6 md3>
                  <v-layout>
                    <v-btn color="info" @click="yenile(500)" fab small dark>
                      <v-icon>search</v-icon>
                    </v-btn>
                    <v-badge color="white" :overlap="true">
                      <template v-slot:badge>
                        <v-icon v-if="filtrevarmi" large color="green"
                          >check_circle_outline</v-icon
                        >
                      </template>

                      <v-btn
                        small
                        @mouseenter="tooltip = true"
                        @mouseleave="tooltip = false"
                        ref="fab"
                        @click="filtreOpen()"
                        color="info"
                        fab
                        dark
                      >
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                    </v-badge>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-form>
    </v-flex>

    <div>
      <v-data-table :headers="headers" :items="response" class="elevation-1">
        <template v-slot:items="props">
          <td>{{ props.item.FaturaTarihi }}</td>

          <td
            v-if="props.item.InvoiceTypeCode == 2"
            style="background-color: #ff0000"
          >
            {{ props.item.InvoiceTypeCodeStr }}
          </td>
          <td v-else>{{ props.item.InvoiceTypeCodeStr }}</td>
          <td>{{ props.item.FaturaNo }}</td>
          <td>{{ props.item.Unvan }}</td>
          <td class="text-xs-right">{{ props.item.Tutar }}</td>
          <td>{{ props.item.ParaBirimi }}</td>
          <td v-if="props.item.AktarimTarihi == '0001-01-01T00:00:00'">
            {{ $t("pending") }}
          </td>
          <td v-else style="background-color: #ff0000">
            {{ $t("Processed") }}
          </td>

          <td class="justify-center layout px-0">
            <v-icon
              small
              class="mr-2"
              @click="FaturaIsleSayfasiniAc(props.item)"
            >
              edit
            </v-icon>
          </td>
        </template>
      </v-data-table>
    </div>

    <v-layout>
      <v-flex xs12 sm6 offset-sm3>
        <v-card>
          <div id="demo"></div>
        </v-card>
      </v-flex>
    </v-layout>
    <customdialog v-model="UBLKayit.dialogShow" title="UBL-TR Fatura Yükleme sonucu" :maxWidth="1000" :cardtextstyle="'height: 420px;'">
      <v-data-table
        :headers="UBLKayit.headers"
        :items="UBLKayit.sonuc"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <td>{{ props.item.UUID }}</td>
          <td>{{ props.item.FileName }}</td>
          <td>{{ props.item.Message }}</td>
        </template>
      </v-data-table>
    </customdialog>
  </basepage>
</template>

<script>
import basepage from "@/components/app/coper/comp/basepage.vue";
import tool from "@/components/app/coper/tools.js";
import tarihcomp from "@/components/app/customcomp/tarihim";
import filedialog from "@/components/app/coper/comp/filedialog.vue";
import customdialog from "@/components/app/coper/comp/customdialog.vue";

export default {
  components: {
    basepage,
    tarihcomp,
    filedialog,
    customdialog,
  },
  data() {
    return {
      status: tool.NewSatatus(),
      filtrevarmi: false,
      UBLKayit: {
        dialogShow: false,
        sonuc: [],
        headers: [
          { text: "UUID", value: "UUID" },
          { text: "FileName", value: "FileName" },
          { text: "Message", value: "Message" },
        ],
      },

      prm: {
        Tarih1: tool.Now_yyyy_MM_dd(),
        Tarih2: tool.Now_yyyy_MM_dd(),
        EttnFaturaNo: "",
      },
      response: [],

      headers: [
        { text: this.$t("Invoice-Date"), value: "FaturaTarihi" },
        { text: this.$t("Invoice-Type"), value: "InvoiceTypeCodeStr" },
        { text: this.$t("Invoice-No"), value: "FaturaNo" },
        { text: this.$t("Title_label"), value: "Unvan" },
        { text: this.$t("Amount"), value: "Tutar" },
        { text: this.$t("Currency-Unit"), value: "ParaBirimi" },
        { text: "Işlendi", value: "Islendi" },

        { text: "Actions", value: "name", sortable: false },
      ],

      aranacak: "",
      menuItems: [
        {
          title: "UBL Dosya Yükle",
        },
      ],
    };
  },
  methods: {
    menuClick(index) {
      if (index == 0) {
        //TODO : Entegratör Ayar sayfası açılacak
        this.$refs.filedialog
          .open("UBL XML Dosya Seçimi", "")
          .then((confirm) => {
            if (confirm !== null) {
              this.Gonder(confirm);
            }
          });
      }
    },

    Gonder(files) {
      if (files.length > 0) {
        this.status.loading = true;

        tool
          .api_file_post2(this, "EFatura/HavuzaKayitUblFile", files, null)
          .then(
            (response) => {
              this.status.loading = false;

              if (response.body.Status == true) {
                this.UBLKayit.dialogShow = true;

                this.UBLKayit.sonuc = response.body.data;
              } else {
                this.status.text = response.body.ErrorList[0];
                this.status.show = true;
              }
            },
            (response) => {
              this.status = tool.responseToStatus(response);
            }
          );
      } else {
        this.sonuc = this.sonuc + this.$t("Applicable-file-not-found");
      }
    },

    Durum(val) {
      if (val.AktarimTarihi == "0001-01-01T00:00:00") {
        return "";
      } else {
        return "Evet";
      }
    },

    kayitgetir() {},

    yenile: yenile,
    FaturaIsleSayfasiniAc: FaturaIsleSayfasiniAc,
  },

  beforeMount: beforeMount,
};

function beforeMount() {
  this.yenile(10);
}

function yenile(milisaniye) {
  this.status.loading = true;
  setTimeout(() => {
    var prm = this.prm;
    tool.api_post(this, "EFatura/GelenEFaturaHavuzList", prm).then(
      (response) => {
        this.status.loading = false;

        if (response.body.Status == true) {
          this.response = response.body.data;
        } else {
          this.status.text = response.body.ErrorList[0];
          this.status.show = true;
        }
      },
      (response) => {
        this.status = tool.responseToStatus(response);
      }
    );
  }, milisaniye);
}

function FaturaIsleSayfasiniAc(val) {
  let url = "#/fatura/gelenEFaturaIsle/id?uuid=" + val.UUID;
  window.open(url, "_blank").focus();
}
</script>
